import { useEffect, useState } from 'react';
import { useLang } from '../i18n/LanguageContext';
import { storefront } from '../lib/supabase';

export default function Contact() {
  const { t } = useLang();
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    storefront.content().then(({ data }) => {
      setInfo((data || []).find((x) => x.key === 'store_info'));
      setLoading(false);
    });
  }, []);

  if (loading) return <div className="loading">{t('misc.loading')}</div>;

  const extra = info?.extra || {};
  const mapsQuery = extra.maps_query || extra.address || 'Nha Trang, Khanh Hoa';

  return (
    <div className="container section">
      <h1>📍 {t('contact.title')}</h1>
      <div className="grid grid-2">
        <div className="card">
          <h3>🌊 Life in Nha Trang</h3>
          <p><strong>{t('contact.address')}:</strong> {extra.address || '—'}</p>
          <p><strong>{t('contact.phone')}:</strong> {extra.phone || '—'}</p>
          <p><strong>{t('contact.email')}:</strong> {extra.email || '—'}</p>
          <p><strong>{t('contact.hours')}:</strong> {extra.hours || '—'}</p>
        </div>
        <iframe
          className="map-frame"
          title="Life in Nha Trang map"
          src={`https://www.google.com/maps?q=${encodeURIComponent(mapsQuery)}&output=embed`}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  );
}
